import { createContext, type FC, type PropsWithChildren, useCallback, useContext, useMemo, useState } from "react";
import { type DisplayableError } from "./DisplayableError";

export interface IErrorContext {
    error: Error | DisplayableError | null;
    setError: (error: Error | DisplayableError) => void;
    resetError: () => void;
}

export const ErrorContext = createContext({} as IErrorContext);

export const useErrorContext = () => {
    return useContext(ErrorContext);
};

export const ErrorContextProvider: FC<PropsWithChildren> = ({ children }) => {
    const [error, setError] = useState<Error | DisplayableError | null>(null);
    const resetError = useCallback(() => {
        setError(null);
    }, []);
    const value = useMemo(() => ({ error, setError, resetError }), [error, resetError]);
    return (
        <ErrorContext.Provider value={value}>
            {children}
        </ErrorContext.Provider>
    );
};
